interface IndustryThreshold {
  industry: string;
  post_performance_threshold_1: number;
  post_performance_threshold_2: number;
}

export const INDUSTRY_THRESHOLDS: IndustryThreshold[] = [
  { "industry": "Beauty & Cosmetics", "post_performance_threshold_1": 0.7, "post_performance_threshold_2": 2 },
  { "industry": "Fashion & Apparel", "post_performance_threshold_1": 0.8, "post_performance_threshold_2": 2.5 },
  { "industry": "Health & Wellness", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "Fitness & Sports", "post_performance_threshold_1": 0.8, "post_performance_threshold_2": 2 },
  { "industry": "Food & Beverage", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "Travel & Tourism", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "Finance & Banking", "post_performance_threshold_1": 0.3, "post_performance_threshold_2": 1 },
  { "industry": "Real Estate", "post_performance_threshold_1": 0.5, "post_performance_threshold_2": 1.5 },
  { "industry": "Technology & Software (SaaS)", "post_performance_threshold_1": 0.3, "post_performance_threshold_2": 1 },
  { "industry": "E-commerce & Online Retail", "post_performance_threshold_1": 0.5, "post_performance_threshold_2": 1.5 },
  { "industry": "Education & E-learning", "post_performance_threshold_1": 0.8, "post_performance_threshold_2": 2 },
  { "industry": "Media & Publishing", "post_performance_threshold_1": 0.8, "post_performance_threshold_2": 2 },
  { "industry": "Entertainment & Events", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "Automotive", "post_performance_threshold_1": 0.5, "post_performance_threshold_2": 1.5 },
  { "industry": "Home & Interior Design", "post_performance_threshold_1": 0.8, "post_performance_threshold_2": 2 },
  { "industry": "Photography & Creative", "post_performance_threshold_1": 1.5, "post_performance_threshold_2": 3.5 },
  { "industry": "Marketing & Advertising", "post_performance_threshold_1": 0.5, "post_performance_threshold_2": 1.5 },
  { "industry": "Legal Services", "post_performance_threshold_1": 0.2, "post_performance_threshold_2": 0.6 },
  { "industry": "Healthcare & Medical", "post_performance_threshold_1": 0.5, "post_performance_threshold_2": 1.5 },
  { "industry": "Nonprofit & Charity", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "Government & Public Sector", "post_performance_threshold_1": 0.3, "post_performance_threshold_2": 1 },
  { "industry": "Consulting & Prof. Services", "post_performance_threshold_1": 0.5, "post_performance_threshold_2": 1.2 },
  { "industry": "Gaming", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "Pets & Animals", "post_performance_threshold_1": 1.5, "post_performance_threshold_2": 3.5 },
  { "industry": "Parenting & Family", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "Luxury & Jewelry", "post_performance_threshold_1": 0.8, "post_performance_threshold_2": 2 },
  { "industry": "Spirituality & Religion", "post_performance_threshold_1": 1.5, "post_performance_threshold_2": 3.5 },
  { "industry": "Green & Sustainability", "post_performance_threshold_1": 1, "post_performance_threshold_2": 3 },
  { "industry": "HR & Recruitment", "post_performance_threshold_1": 0.3, "post_performance_threshold_2": 1 },
  { "industry": "Construction & Architecture", "post_performance_threshold_1": 0.5, "post_performance_threshold_2": 1.5 }
]


// Slider configuration constants
export const SLIDER_CONFIG = {
  MIN: 0,
  MAX: 100,
  STEP: 1,
  DEFAULT_VALUES: [10, 40] as [number, number]
};